import { combineReducers } from 'redux'

import awardReducer from './award-reducer'
import awardsReducer from './awards-reducer'

export default combineReducers({
  awards: awardsReducer,
  award: awardReducer,
})
